<template>
  <div>
    <NavBar />
    <AuthBySessionExpired />
    <div class="container">
      <div class="row">
        <div class="col-xl-1 col-lg-2 col-md-2 col-sm-3 col-12">
          <v-btn class="btn-return" @click="handleToBack">
            <i class="fas fa-arrow-left mr-2 text-twenty"></i> Voltar
          </v-btn>
        </div>
        <div class="col-xl-11 col-lg-10 col-md-10 col-sm-9 col-12">
          <h1 class="title-pages mt-1">MEDICAMENTO: {{ name }}</h1>
          <h6>
            TIPO:
            {{ type == "CASA_DE_REPOUSO" ? "EMPRESA" : "PADRÃO" }}
          </h6>
        </div>
      </div>
      <b-overlay :show="loading" opacity="0.99">
        <form v-on:submit="update" method="post">
          <WarningMessage
            v-if="!permission('edit', 'medicine')"
            message="Você não tem permissão para modificar medicamentos"
          />
          <WarningMessage
            v-if="type == 'PADRAO'"
            message="ESTE MEDICAMENTO É PADRÃO, POR ISSO NÃO PODE SER ALTERADO QUAISQUER INFORMAÇÕES!"
          />
          <div class="row">
            <div
              class="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12 pt-0 pb-0"
            >
              <LabelRequiredField label="NOME COMERCIAL" />
              <input
                :disabled="!permission('edit', 'medicine') || type == 'PADRAO'"
                type="text"
                ref="autofocus"
                v-model="name"
                class="form-control"
              />
            </div>
            <div
              class="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12 pt-0 pb-0"
            >
              <SelectActiveIngredientID
                :disabled="!permission('edit', 'medicine') || type == 'PADRAO'"
                v-model="active_ingredient_id"
                v-if="renderActiveIngredientID"
              />
            </div>
            <div class="col-xl-4 col-lg-4 col-md-6 col-sm-6 col-12 pt-0 pb-0">
              <label>LISTA</label>
              <select
                :disabled="!permission('edit', 'medicine') || type == 'PADRAO'"
                v-model="list"
                class="form-control"
              >
                <option value>SELECIONE...</option>
                <option
                  v-for="value in lists"
                  :key="value.id"
                  :value="value.name"
                >
                  {{ String(value.name).toUpperCase() }}
                </option>
              </select>
            </div>
            <div class="col-xl-4 col-lg-4 col-md-6 col-sm-6 col-12 pt-0 pb-0">
              <label>TIPO DE RECEITA</label>
              <select
                :disabled="!permission('edit', 'medicine') || type == 'PADRAO'"
                v-model="type_of_recipe_id"
                class="form-control"
              >
                <option value>SELECIONE...</option>
                <option
                  v-for="value in typesOfRecipe"
                  :key="value.id"
                  :value="value.id"
                >
                  {{ String(value.name).toUpperCase() }}
                </option>
              </select>
            </div>
            <div class="col-xl-4 col-lg-4 col-md-6 col-sm-6 col-12 pt-0 pb-0">
              <LabelRequiredField label="UNIDADE DE MEDIDA" />
              <select
                disabled
                v-model="unit_of_measurement_id"
                class="form-control"
              >
                <option
                  v-for="value in unitOfMeasurements"
                  :key="value.id"
                  :value="value.id"
                >
                  {{ value.name }}
                </option>
              </select>
            </div>
            <div class="col-xl-4 col-lg-4 col-md-6 col-sm-6 col-12 pt-0 pb-0">
              <label>CLASSE TERAPÊUTICA</label>
              <input
                :disabled="!permission('edit', 'medicine') || type == 'PADRAO'"
                type="text"
                v-model="therapeutic_class"
                class="form-control"
              />
            </div>
            <div class="col-xl-4 col-lg-4 col-md-6 col-sm-6 col-12 pt-0 pb-0">
              <label>TIPO DE MEDICAMENTO</label>
              <select
                :disabled="!permission('edit', 'medicine') || type == 'PADRAO'"
                v-model="type_of_medicine_id"
                class="form-control"
              >
                <option value>SELECIONE...</option>
                <option
                  v-for="value in typesOfMedicine"
                  :key="value.id"
                  :value="value.id"
                >
                  {{ String(value.name).toUpperCase() }}
                </option>
              </select>
            </div>
            <div
              v-if="type == 'CASA_DE_REPOUSO'"
              class="col-xl-4 col-lg-4 col-md-6 col-sm-6 col-12 pt-0 pb-0"
            ></div>
            <div
              v-if="type == 'CASA_DE_REPOUSO' && false"
              class="col-xl-4 col-lg-4 col-md-6 col-sm-6 col-12 pt-0 pb-0"
            >
              <LabelRequiredField label="CUSTO DO MEDICAMENTO" />
              <input
                :disabled="!permission('edit', 'medicine') || type == 'PADRAO'"
                type="text"
                v-model="medicine_cost"
                class="form-control"
                v-on:keyup="handleValueMedicineCost"
              />
            </div>
            <div
              v-if="type == 'CASA_DE_REPOUSO' && false"
              class="col-xl-4 col-lg-4 col-md-6 col-sm-6 col-12 pt-0 pb-0"
            >
              <label>LUCRO(%)</label>
              <input
                :disabled="!permission('edit', 'medicine') || type == 'PADRAO'"
                type="text"
                v-on:keyup="handleValueProfit"
                v-model="profit"
                class="form-control"
              />
            </div>
            <div
              v-if="type == 'CASA_DE_REPOUSO' && false"
              class="col-xl-4 col-lg-4 col-md-6 col-sm-6 col-12 pt-0 pb-0"
            >
              <LabelRequiredField label="VALOR DA VENDA" />
              <input
                :disabled="!permission('edit', 'medicine') || type == 'PADRAO'"
                type="text"
                v-model="sale_price"
                class="form-control"
                v-on:keyup="handleValueSalePrice"
              />
            </div>
            <div class="col-md-12" v-if="type == 'CASA_DE_REPOUSO'">
              <h6 class="mb-0 worksansr">
                Criação:
                {{ formatDate(created_at) }}
              </h6>
              <h6 class="mb-0 worksansr">
                Última alteração:
                {{ formatDate(updated_at) }}
              </h6>
            </div>
            <div
              class="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12"
              v-if="type == 'CASA_DE_REPOUSO'"
            >
              <WarningRequiredFields />
            </div>
            <div
              class="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12 pt-0 pb-0"
            >
              <ErrorsMessages :errors="errors" />
            </div>
            <div
              class="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12 text-right pt-0 pb-0"
            >
              <v-btn
                v-if="
                  permission('edit', 'medicine') && type == 'CASA_DE_REPOUSO'
                "
                :disabled="loading"
                type="submit"
                class="btn-save"
              >
                <i class="fas fa-save mr-2 text-twenty"></i>
                {{ loading ? "CARREGANDO" : "SALVAR" }}
              </v-btn>
            </div>
          </div>
        </form>
      </b-overlay>
    </div>
  </div>
</template>

<script>
import NavBar from "../NavBar";
import AuthBySessionExpired from "../Components/AuthBySessionExpired";
import ErrorsMessages from "../Components/ErrorsMessages";
import WarningMessage from "../Components/WarningMessage";
import WarningRequiredFields from "../Components/WarningRequiredFields";
import LabelRequiredField from "../Components/LabelRequiredField";

import SelectActiveIngredientID from "../Components/SelectActiveIngredientID";

import api from "../../services/api";

import routes from "../../routes";

import toast from "../../lib/ToastNotification";

import permission from "../../lib/permission";

import {
  formatPrice,
  formatValueOnKeyUp,
  formatValueToOnlyNumber,
  formatValueToPercentage,
  formatDate,
} from "../../lib/format";

export default {
  name: "Medicines",
  components: {
    NavBar,
    AuthBySessionExpired,
    ErrorsMessages,
    WarningMessage,
    WarningRequiredFields,
    LabelRequiredField,
    SelectActiveIngredientID,
  },
  data() {
    return {
      lists: [
        { id: 1, name: "A1" },
        { id: 2, name: "A2" },
        { id: 3, name: "A3" },
        { id: 4, name: "B1" },
        { id: 5, name: "C1" },
        { id: 6, name: "C5" },
        { id: 7, name: "D1" },
      ],
      unitOfMeasurements: [],
      typesOfMedicine: [],
      typesOfRecipe: [],
      unit_of_measurement_id: "",
      type_of_medicine_id: "",
      type_of_recipe_id: "",
      id: "",
      name: "",
      therapeutic_class: "",
      active_ingredient: [],
      active_ingredient_id: "",
      type: "",
      list: "",
      medicine_cost: "",
      profit: "",
      sale_price: "",
      loading: true,
      errors: [],
      renderActiveIngredientID: false,
    };
  },
  created() {
    this.retrieve();
  },
  methods: {
    permission,
    formatPrice,
    formatValueOnKeyUp,
    formatValueToOnlyNumber,
    formatValueToPercentage,
    formatDate,

    handleToBack: () => routes.go(-1),

    handleValueProfit: function (e) {
      var profit = formatValueToPercentage(e.target.value);
      if (profit) {
        var current = formatValueToOnlyNumber(this.medicine_cost);
        var percentage = profit * current;
        var sale_price = percentage / 100;
        sale_price = parseFloat(sale_price) + parseFloat(current);
        this.sale_price = formatPrice(sale_price);
      } else {
        this.sale_price = formatPrice(0);
      }
    },

    handleValueMedicineCost: function (e) {
      this.medicine_cost = formatValueOnKeyUp(e.target.value);

      var current = formatValueToOnlyNumber(e.target.value);
      var sale_price = formatValueToOnlyNumber(this.sale_price);

      if (parseInt(current) <= parseInt(sale_price)) {
        var percentage = parseFloat(sale_price - current);
        var profit = percentage * 100;
        profit = profit / current;
        profit = String(profit);
        this.profit = profit.replace(".", ",");
      }
    },

    handleValueSalePrice: function (e) {
      this.sale_price = formatValueOnKeyUp(e.target.value);

      var current = formatValueToOnlyNumber(this.medicine_cost);
      var sale_price = formatValueToOnlyNumber(e.target.value);

      if (parseInt(current) <= parseInt(sale_price)) {
        var percentage = parseFloat(sale_price - current);
        var profit = percentage * 100;
        profit = profit / current;
        profit = String(profit);
        this.profit = profit.replace(".", ",");
      }
    },

    async retrieve() {
      let { id } = routes.currentRoute.params;

      if (!id) {
        return routes.go(-1);
      }

      this.id = id;

      await this.get();
      await this.getUnitOfMeasurements();
      await this.getActiveIngredient();
      await this.getTypesOfMedicine();
      await this.getTypesOfRecipe();
    },

    async get() {
      try {
        this.loading = true;

        let { id } = this;

        const params = { id };

        const response = await api.get("/rest-home/medicine/get", { params });

        const { error, errors, medicine } = response.data;

        if (error) {
          this.errors = errors;
        } else {
          this.unit_of_measurement_id = medicine.unit_of_measurement_id;
          this.type_of_medicine_id = medicine.type_of_medicine_id;
          this.type_of_recipe_id = medicine.type_of_recipe_id;
          this.name = medicine.name;
          this.therapeutic_class = medicine.therapeutic_class;
          this.active_ingredient_id = medicine.active_ingredient_id;
          this.list = medicine.list;
          this.type = medicine.type;
          this.medicine_cost = formatPrice(medicine.medicine_cost);
          this.profit = medicine.profit;
          this.sale_price = formatPrice(medicine.sale_price);
          this.updated_at = medicine.updated_at;
          this.created_at = medicine.created_at;
          this.renderActiveIngredientID = true;
        }

        this.loading = false;
      } catch (error) {
        console.log(error);
      }
    },

    async getUnitOfMeasurements() {
      try {
        const response = await api.get("/rest-home/unit-of-measurement/all");

        const { error, errors, unit_of_measurement } = response.data;

        if (error) {
          this.errors = errors;
        } else {
          this.errors = [];
          this.unitOfMeasurements = unit_of_measurement;
        }
      } catch (error) {
        console.log(error);
      }
    },

    async getActiveIngredient() {
      try {
        const response = await api.get("/rest-home/active-ingredients");

        const { error, errors, active_ingredient } = response.data;

        if (error) {
          this.errors = errors;
        } else {
          this.errors = [];
          this.active_ingredient = active_ingredient;
        }
      } catch (error) {
        console.log(error);
      }
    },

    async getTypesOfMedicine() {
      try {
        const response = await api.get("/rest-home/type-of-medicine/all");

        const { error, errors, types } = response.data;

        if (error) {
          this.errors = errors;
        } else {
          this.errors = [];
          this.typesOfMedicine = types;
        }
      } catch (error) {
        console.log(error);
      }
    },

    async getTypesOfRecipe() {
      try {
        const response = await api.get("/rest-home/type-of-recipe/all");

        const { error, errors, types } = response.data;

        if (error) {
          this.errors = errors;
        } else {
          this.errors = [];
          this.typesOfRecipe = types;
        }
      } catch (error) {
        console.log(error);
      }
    },

    async update(event) {
      try {
        event.preventDefault();

        this.renderActiveIngredientID = false;
        this.loading = true;

        const {
          id,
          unit_of_measurement_id,
          active_ingredient_id,
          type_of_medicine_id,
          type_of_recipe_id,
          name,
          therapeutic_class,
          medicine_cost,
          profit,
          sale_price,
          list,
        } = this;

        let params = {
          id,
          unit_of_measurement_id,
          active_ingredient_id,
          type_of_medicine_id,
          type_of_recipe_id,
          name,
          therapeutic_class,
          medicine_cost,
          profit,
          sale_price,
          list,
        };

        const response = await api.put("/rest-home/medicine/update", params);

        const { error, errors, message } = response.data;

        if (!error) {
          this.errors = [];
          toast(message, "success");
          this.get();
        } else {
          this.errors = errors;
        }

        this.renderActiveIngredientID = true;
        this.loading = false;
      } catch (error) {
        console.log(error);
      }
    },
  },
};
</script>
